import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import IconButton from 'components/IconButton/IconButton';
import Modal from 'components/Modal/Modal';
import { TABLE_HEADERS_SUPPLIERS } from 'constants/dataSets';
import formattedNumberWithComma from 'utils/formattedNumberWithComma';

import type ITableModal from './interfaces/ITableModal';

import styles from './scss/TableModal.module.scss';

function TableModal({
  open,
  title,
  data,
  onClose,
  className,
  headers = TABLE_HEADERS_SUPPLIERS,
}: ITableModal) {
  const { t } = useTranslation();
  const hyphen = t('common.hyphen');
  return (
    <Modal
      open={open}
      className={`${styles.modal} ${className}`}
      onClose={onClose}
      isButtonsVisible={false}
    >
      <IconButton
        className={styles.closeIcon}
        size="small"
        icon={<CloseIcon />}
        onClick={onClose}
      />
      <div className={styles.header}>
        <h2>{title}</h2>
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((headerKey, index) => (
                <th key={headerKey} className={`${styles.tableHeader} ${index < 3 ? styles.textWrap : ''}`}>
                  {t(headerKey)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.profitCenterId} className={styles.tableRow}>
                <td className={styles.tableCell}>{item.profitCenterId}</td>
                <td className={styles.tableCell}>{item.startDate}</td>
                <td className={styles.tableCell}>{item.endDate}</td>
                <td className={styles.tableCell}>
                  {item.totalCost}
                </td>
                <td className={styles.tableCell}>
                  {item.percentOfTotalCost ? `${formattedNumberWithComma(item.percentOfTotalCost)} %` : hyphen}
                </td>
                <td className={styles.tableCell}>
                  {item.expectedGrowthDecline ? `${formattedNumberWithComma(item.expectedGrowthDecline)} %` : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
}

export default TableModal;
